import React, { useState, useEffect } from 'react';
import { Container, TextField, Button, Box } from '@mui/material';
import { MenuInicial } from "./MenuInicial";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL, USUARIOACCIONLISTAR } from '../services/apiConfig';
import { DataGrid } from '@mui/x-data-grid';
import Cargando from './utils/Cargando.jsx';
import axios from 'axios';

import esLocale from 'date-fns/locale/es';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.css';

function UsuarioAccionesList() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const sucursalid = userData?.sucursalid;
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const handleSearchChange = (e) => {
    const term = e.target.value;
    setSearchTerm(term);

    const filteredData = users.filter((user) =>
      user.navego.toLowerCase().includes(term.toLowerCase())
    );
    setFilteredUsers(filteredData);
  };

  const handleStartDate = (date) => {
    setStartDate(date);
  };

  const handleEndDate = (date) => {
    setEndDate(date);
  };

  useEffect(() => {
    /*const loggedIn = sessionStorage.getItem("loggedIn");
    if (!loggedIn) {
      navigate("/login");
    }*/
    handleUpdateData();
  }, []);

  const handleUpdateData = () => {
    setLoading(true);

    const fechainicio = startDate;
    const date = new Date(fechainicio);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    const fechainiciod = `${year}-${month}-${day}`;

    const fechafin = endDate;
    const datef = new Date(fechafin);

    const yearf = datef.getFullYear();
    const monthf = String(datef.getMonth() + 1).padStart(2, '0');
    const dayf = String(datef.getDate()).padStart(2, '0');

    const fechainiciof = `${yearf}-${monthf}-${dayf}`;

    axios.get(`${API_BASE_URL}${USUARIOACCIONLISTAR}?s=${sucursalid}&startDate=${fechainiciod}&endDate=${fechainiciof}`)
      .then((response) => {
        const userData = response.data;
        setUsers(userData); // Actualiza la lista de usuarios
        const filteredData = userData.filter(user => user.navego.toLowerCase().includes(searchTerm.toLowerCase()));
        setFilteredUsers(filteredData);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al cargar los pedidos', error);
        setLoading(false);
      });
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'fecha', headerName: 'Fecha', width: 155 },
    { field: 'username', headerName: 'Nombre de usuario', width: 200 },
    { field: 'navego', headerName: 'Navego', width: 250 },
    { field: 'ip', headerName: 'IP', width: 200 },
    // Agrega más columnas según tus necesidades
  ];

  return (
    <div>
      <Container>
        <MenuInicial></MenuInicial>
        <div className='miDiv'><h2>Usuarios acciones</h2></div>
        <Box display="flex" alignItems="center">
          <div className='miDiv' style={{ display: 'flex', gap: '16px' }}>
            <DatePicker
              onChange={handleStartDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Fecha de inicio"
              locale={esLocale}
              selected={startDate}
              maxDate={new Date()}
            />
            <DatePicker
              onChange={handleEndDate}
              dateFormat="dd/MM/yyyy"
              placeholderText="Fecha de fin"
              locale={esLocale}
              selected={endDate}
              maxDate={new Date()}
            />
            <Button onClick={handleUpdateData} variant="contained" color="primary">
              Actualizar
            </Button>
          </div>
        </Box>
        <TextField
          label="Buscar por Navego"
          value={searchTerm}
          onChange={handleSearchChange}
        />
        <div>
          {loading ? (
            <Cargando></Cargando>
          ) : (
            <DataGrid rows={filteredUsers} columns={columns} />
          )}
        </div>
      </Container>
    </div>
  );
}

export default UsuarioAccionesList;
